export default __webpack_public_path__ + "static/media/itunes.a2efc07e.svg";